import axios from 'axios';

// Tag filters survive a reload as bare ids in the URL, but TagSelector renders
// chips from full {value, label, color} options — so look the tags back up.
export default async function fetchTagsByIds(ids) {
    const list = (Array.isArray(ids) ? ids : String(ids ?? '').split(','))
        .map(id => String(id).trim())
        .filter(Boolean);

    if (!list.length) return [];

    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/tags`, {
            params: {
                page: 1,
                limit: list.length,
                'filters[0][column]': 'id',
                'filters[0][operator]': 'IN',
                'filters[0][value]': list,
            },
            headers: {
                'access-token': localStorage.getItem('accessToken'),
            },
        });

        const tags = response.data?.tags || response.data?.data || [];
        return tags.map(tag => ({ value: tag.id, label: tag.name, color: tag.color }));
    } catch (error) {
        console.error('Failed to fetch tags by id', error);
        return [];
    }
}
